import React from 'react'
import styled from 'styled-components';
import bot1 from '../../assets/avatars/bot-1.svg'

export default function Avatar({ src, width}) {

    return (
        <>
            {src ? (
                <Img src={src} alt="Avatar de usuario" width={width}></Img>
            ) :
                <Img src={bot1} alt="Avatar de usuario" width={width}></Img>}
        </>
    )
}

const Img = styled.img`
    background-color: var(--color-gris-claro);
    border-radius: 50%;
    padding:1%;
    text-align: center;
    width:${props=> props.width ? props.width : '40px'};
`;